<div class="loyalty-badge-modal">
  <div>
    <div *ngIf="badgeName === LoyaltyBadgeNames.SUPERSTAR">
      <mable-heading heading="h3">Superstar badge</mable-heading>
      <p>
        This special badge is awarded to independent support workers who consistently deliver great support. To earn it,
        support workers need to:
      </p>
      <ul class="tick-list">
        <li>
          <ion-icon
            name="checkmark"
            size="small"
          />
          Complete 100 hours on Mable in the last 3 months.
        </li>
        <li>
          <ion-icon
            name="checkmark"
            size="small"
          />
          Support at least 2 clients on Mable.
        </li>
        <li>
          <ion-icon
            name="checkmark"
            size="small"
          />
          Maintain positive behaviour on the platform.
        </li>
      </ul>
    </div>

    <div *ngIf="badgeName === LoyaltyBadgeNames.NEW">
      <mable-heading heading="h3">New on Mable badge</mable-heading>
      <p>This badge recognises new independent support workers who have recently joined the Mable platform.</p>
    </div>

    <a
      class="font-weight-semi-bold link"
      (click)="learnMore()"
      >Learn more about Mable badges</a
    >
  </div>
  <mable-button (onClick)="dismiss()">Ok, got it</mable-button>
</div>
